import React from 'react'
import { Box, Button } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import GroupIcon from '@mui/icons-material/Group'
import InventoryIcon from '@mui/icons-material/Inventory'
import BarChartIcon from '@mui/icons-material/BarChart'
import SummarizeIcon from '@mui/icons-material/Summarize'
import { adminColors } from '../adminStyles'

const navItems = [
  { label: 'Accounts', icon: <GroupIcon sx={{ fontSize: 18 }} />, route: '/admin/accounts' },
  { label: 'Products', icon: <InventoryIcon sx={{ fontSize: 18 }} />, route: '/admin/products' },
  {
    label: 'User Product Report',
    icon: <BarChartIcon sx={{ fontSize: 18 }} />,
    route: '/admin/user-product-report',
  },
  {
    label: 'Auto Trade Report',
    icon: <SummarizeIcon sx={{ fontSize: 18 }} />,
    route: '/admin/auto-trade-report',
  },
]

export default function AdminNav() {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        mb: 3,
        borderBottom: `1px solid ${adminColors.border}`,
        bgcolor: adminColors.cardBg,
        mx: -4,
        px: 4,
      }}
    >
      {navItems.map((item) => {
        const isActive = location.pathname.startsWith(item.route)
        return (
          <Button
            key={item.label}
            startIcon={item.icon}
            onClick={() => navigate(item.route)}
            sx={{
              textTransform: 'none',
              fontWeight: isActive ? 600 : 400,
              fontSize: '0.825rem',
              color: isActive ? adminColors.accent : adminColors.textSecondary,
              borderBottom: isActive ? `2px solid ${adminColors.accent}` : '2px solid transparent',
              borderRadius: 0,
              px: 2,
              py: 1.5,
              minHeight: 0,
              transition: 'color 0.15s ease, border-color 0.15s ease',
              '&:hover': {
                color: adminColors.accent,
                backgroundColor: adminColors.accentHover,
              },
            }}
          >
            {item.label}
          </Button>
        )
      })}
    </Box>
  )
}
